import {type List} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {TRACK_ACTION_PAYLOAD_KEY} from 'web-app/util/famlytics/action-tracking-constants';

const domain = 'INVITE_PARENTS';

export const {
    action: fetchChildren,
    success: fetchChildrenSuccess,
    failed: fetchChildrenFailed,
} = createAction(
    `${domain}/FETCH_CHILDREN_AND_PLANS`,
    (
        institutionId: string,
        embedRelations: boolean,
        includeFuture: boolean,
        includePast: boolean,
        updateEntities: boolean,
    ) => ({institutionId, embedRelations, includeFuture, includePast, updateEntities}),
    (children: List<any>) => ({children}),
);

export const {action: toggleLoginId} = createAction(`${domain}/TOGGLE_LOGIN_ID`, (relationId: string) => ({
    relationId,
}));

export const {action: setAll} = createAction(`${domain}/SET_ALL`, (setTo: boolean) => ({setTo}));

export const {action: setRole} = createAction(`${domain}/SET_ROLE`, (relationId: string, roleId: string) => ({
    relationId,
    roleId,
}));

interface AssignRoleProps {
    relationId: string;
    newRoleId: boolean;
    famlyId: string;
    roleTargetId: string;
}

export const {action: assignRoles} = createAction(`${domain}/ASSIGN_ROLES`, (assignees: List<AssignRoleProps>) => ({
    assignees,
    [TRACK_ACTION_PAYLOAD_KEY]: {numberOfContacts: assignees.size},
}));

export const {
    action: assignRole,
    success: assignRoleSuccess,
    failed: assignRoleFailed,
} = createAction(
    `${domain}/ASSIGN_ROLE`,
    (relationId: string, assigneeProps: AssignRoleProps) => ({
        relationId,
        assigneeProps,
        [TRACK_ACTION_PAYLOAD_KEY]: {case: 'contacts invited', relation: relationId},
    }),
    (relationId: string) => ({relationId}),
    (relationId: string) => ({relationId}),
);

export const {action: assignRoleInvitations} = createAction(
    `${domain}/ASSIGN_ROLE_INVITATIONS`,
    (assignees: List<AssignRoleProps>) => ({
        assignees,
        [TRACK_ACTION_PAYLOAD_KEY]: {numberOfContacts: assignees.size},
    }),
);

export const {action: assignRoleInvitation} = createAction(
    `${domain}/ASSIGN_ROLE_INVITATION`,
    (relationId: string) => ({relationId}),
);

export const {action: cancelInvites} = createAction(`${domain}/CANCEL_INVITES`, () => ({}));
